import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { ISparkFooterConfig } from './footer.interface';


@Component({
    selector: 'spark-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SparkFooterComponent implements OnInit {

	//** Configuration */
	readonly CURRENT_YEAR: number = new Date().getFullYear();

	//** Input Properties */
	@Input() config!: ISparkFooterConfig;


	ngOnInit(): void {

		// check if footer config is provided
		if (!this.config) throw new Error(`SparkFooterComponent => ngOnInit => FATAL ERROR: Footer config is not provided.`);
	}
}
